var _defs, _path, _path2, _g, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameShowsInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7312c;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,58.56c-10.31,0-18.7-8.39-18.7-18.7v-12.95c0-10.31,8.39-18.7,18.7-18.7s18.7,8.39,18.7,18.7v12.95c0,10.31-8.39,18.7-18.7,18.7ZM40,11.2c-8.66,0-15.7,7.04-15.7,15.7v12.95c0,8.66,7.04,15.7,15.7,15.7s15.7-7.04,15.7-15.7v-12.95c0-8.66-7.04-15.7-15.7-15.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,64.09c-13.53,0-24.53-11.01-24.53-24.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,11.87,9.66,21.53,21.53,21.53s21.54-9.66,21.54-21.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,13.53-11.01,24.53-24.54,24.53Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.37,26.85h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.37,32.2h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.37,37.55h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.37,42.9h-6.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.27,26.85h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.27,32.2h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.27,37.55h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.27,42.9h-6.63c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h6.63c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.5,
    y: 62.59,
    width: 3,
    height: 7.71
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.27,71.8H23.73c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h32.54c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameShowsInactive);
export default __webpack_public_path__ + "static/media/GameShows-inactive.e3cfa35154d1803337dba070c15a865c.svg";
export { ForwardRef as ReactComponent };